export const GREEN = '#0ad794';
export const ORANGE = '#ff9f48';
export const RED = '#ff686f';
export const BLUE = '#47b2ff';
export const GRAY = '#c3c3c3';
